export default "__VITE_ASSET__ClSb_hKw__"